import apisService from 'src/shared/apis';

export const saveTableService = apisService.saveTable;
export const getTablesByDbId = apisService.getDatabaseRawTables;
export const refreshService = apisService.refreshColumnAnalysis;
export const getRefreshService = apisService.getColumnAnalysis;
